var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9497 18.364L12 13.4142L7.05025 18.364C6.66134 18.7529 6.02495 18.7529 5.63604 18.364C5.24713 17.9751 5.24713 17.3387 5.63604 16.9498L10.5858 12L5.63604 7.05027C5.24713 6.66136 5.24713 6.02496 5.63604 5.63606C6.02495 5.24715 6.66134 5.24715 7.05025 5.63606L12 10.5858L16.9497 5.63606C17.3387 5.24715 17.9751 5.24715 18.364 5.63606C18.7529 6.02496 18.7529 6.66136 18.364 7.05027L13.4142 12L18.364 16.9498C18.7529 17.3387 18.7529 17.9751 18.364 18.364C17.9751 18.7529 17.3387 18.7529 16.9497 18.364Z",
    fill: "#8E8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.fa059c9ab37c182574d2fcc51fa0fed1.svg";
export { ForwardRef as ReactComponent };